import { useQuery } from '@tanstack/react-query';

import CustomerService from '@/services/CustomerService';

export const GET_METRICS_TOTALIZERS_KEY = ['metrics-totalizers'];

export function useGetMetricsTotalizers() {
  const { data, isLoading } = useQuery({
    queryKey: GET_METRICS_TOTALIZERS_KEY,
    queryFn: () => CustomerService.getMetricsTotalizers(),
  });

  return {
    metrics: data,
    isLoading: isLoading,
  };
}
